import { forwardRef } from 'react';
import IconBase from '../IconBase';
import { Icon } from '../types';

const Distance: Icon = forwardRef((props, ref) => (
  <IconBase viewBoxBase={780} ref={ref} {...props}>
    <path d='m120 150h460v30h-460z' />
    <path d='m120 630 145-400c5.69-15.56 22.92-23.56 38.48-17.87s-148.48 417.87-148.48 417.87m505 0-145-400c-5.69-15.56-22.92-23.56-38.48-17.87s148.48 417.87 148.48 417.87m-250-90v90h30v-60c0-16.57-13.43-30-30-30zm0-165v90h30v-60c0-16.57-13.43-30-30-30zm0-165v90h30v-60c0-16.57-13.43-30-30-30zm285-30h-180v-30h150c16.57 0 30 13.43 30 30z' />
  </IconBase>
));

Distance.displayName = 'Distance';

export default Distance;
